import { render, staticRenderFns } from "./notification-success.vue?vue&type=template&id=a351a8ee&"
import script from "./notification-success.vue?vue&type=script&lang=js&"
export * from "./notification-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports